import { useState } from 'react';
import '../styles/GeneralStyles.css';
import '../styles/UserDataStyles.css';
import imgAnilloBodasPrev from '../assets/anillo-de-bodas-preview.webp';
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'

const UserData = ({ nextStep, prevStep, handleInputChange, formData }) => {
  const [formState, setFormState] = useState({
    firstName: formData?.firstName || '',
    lastName: formData?.lastName || '',
    email: formData?.email || '',
    phone: formData?.phone || '',
    termsAccepted: formData?.termsAccepted || false
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    
    if (!formState.firstName.trim()) {
      newErrors.firstName = 'El nombre es requerido';
    }
    
    if (!formState.lastName.trim()) {
      newErrors.lastName = 'El apellido es requerido';
    }
    
    if (!formState.email.trim()) {
      newErrors.email = 'El email es requerido';
    } else if (!/\S+@\S+\.\S+/.test(formState.email)) {
      newErrors.email = 'Email inválido';
    }
    
    if (!formState.phone.trim()) {
      newErrors.phone = 'El teléfono es requerido';
    }
    
    if (!formState.termsAccepted) {
      newErrors.termsAccepted = 'Debes aceptar los términos y condiciones';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    setFormState(prev => ({
      ...prev,
      [name]: newValue
    }));
    handleInputChange(name, newValue);
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
            <h2 className='heading-style-h3 text-align-center'>Tu Cotización Estimada</h2>
            <p className='text-size-medium text-color-grey'>Comparte tus datos para que recibas tu cotización</p>
            
            <div className="form-container">
              <div className='form2Columns'>
                <div className="form-group">
                  <label htmlFor="firstName" className="form-label">Nombre</label>
                  <input
                    id="firstName"
                    type="text"
                    name="firstName"
                    value={formState.firstName}
                    onChange={handleChange}
                    className={`form-input ${errors.firstName ? 'error' : ''}`}
                  />
                  {errors.firstName && <span className="error-message">{errors.firstName}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="lastName" className="form-label">Apellido</label>
                  <input
                    id="lastName"
                    type="text"
                    name="lastName"
                    value={formState.lastName}
                    onChange={handleChange}
                    className={`form-input ${errors.lastName ? 'error' : ''}`}
                  />
                  {errors.lastName && <span className="error-message">{errors.lastName}</span>}
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">Correo</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formState.email}
                  onChange={handleChange}
                  className={`form-input ${errors.email ? 'error' : ''}`}
                />
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="phone" className="form-label">Teléfono</label>
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  value={formState.phone}
                  onChange={handleChange}
                  className={`form-input ${errors.phone ? 'error' : ''}`}
                />
                {errors.phone && <span className="error-message">{errors.phone}</span>}
              </div>

              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="termsAccepted"
                    checked={formState.termsAccepted}
                    onChange={handleChange}
                  />
                  <span>Acepto los términos y condiciones</span>
                </label>
                {errors.termsAccepted && <span className="error-message">{errors.termsAccepted}</span>}
              </div>
            </div>
          </div>

          <div className="wrapp-btns">
            <button className="button-prev" onClick={prevStep}>
              <img src={iconArrowLeft} alt="arrow left" />
              Volver
            </button>
            <button 
              className="button" 
              onClick={nextStep}
              disabled={!formState.firstName || !formState.lastName || !formState.email || !formState.phone || !formState.termsAccepted}
            >
              Siguiente
              <img src={iconArrowRight} alt="arrow right" />
            </button>
          </div>
        </div>

        <div className="preview-column">
          <div className="decorative-img">
            <img src={imgAnilloBodasPrev} className='imgPreviewNoText' alt="Preview anillo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserData;


